import { render, staticRenderFns } from "./QuotationVSingle.vue?vue&type=template&id=eb5cb268&scoped=true"
import script from "./QuotationVSingle.vue?vue&type=script&lang=js"
export * from "./QuotationVSingle.vue?vue&type=script&lang=js"
import style0 from "./QuotationVSingle.vue?vue&type=style&index=0&id=eb5cb268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5cb268",
  null
  
)

export default component.exports